import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './dynamictable.module.scss';
import React from 'react';

export interface DynamicTableRow {
    rowLabel: ReactNode;
    items: ReactNode[];
}

export interface DynamicTableProps {
    cornerLabelAriaText?: string;
    columnLabels: ReactNode[];
    rows: DynamicTableRow[];
    isMobile?: boolean;
}

export function DynamicTable({
    cornerLabelAriaText,
    rows,
    columnLabels,
    isMobile,
}: DynamicTableProps): React.JSX.Element {
    if (isMobile) {
        return (
            <div role="table" className={cn('medium', styles.mobileTable)}>
                <div role="row" className={styles.mobileRow}>
                    <div role="columnheader" className={styles.mobileCell}>
                        {cornerLabelAriaText && <div className="show-for-sr">{cornerLabelAriaText}</div>}
                    </div>
                    {columnLabels.map((columnLabel, index) => (
                        <div role="columnheader" className={cn(styles.label, styles.mobileCell)} key={index}>
                            {columnLabel}
                        </div>
                    ))}
                </div>
                {rows?.map(({ rowLabel, items }, index) => (
                    <div role="row" className={styles.mobileRow} key={index}>
                        <div role="rowheader" className={cn(styles.label, styles.mobileCell)}>
                            {rowLabel}
                        </div>

                        {items.map((item, index) => (
                            <div role="cell" className={cn(styles.cellLabel, styles.mobileCell)} key={index}>
                                {item || <>&nbsp;</>}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div role="table" className={cn('text-small', styles.table)}>
            <div role="row" className={styles.row}>
                <div role="columnheader" className={styles.cell}>
                    {cornerLabelAriaText && <div className="show-for-sr">{cornerLabelAriaText}</div>}
                </div>

                {columnLabels.map((columnLabel, index) => (
                    <div role="columnheader" className={cn(styles.label, styles.cell)} key={index}>
                        {columnLabel}
                    </div>
                ))}
            </div>

            {rows?.map(({ rowLabel, items }, index) => (
                <div role="row" className={styles.row} key={index}>
                    <div role="rowheader" className={cn(styles.label, styles.cell)}>
                        {rowLabel}
                    </div>

                    {items.map((item, index) => (
                        <div role="cell" className={cn('bold', styles.cell)} key={index}>
                            {item || <>&nbsp;</>}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
